import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromFormulary from './+state/formulary/formulary.reducer';

import { PdlViewerSharedGatewayModule } from '@cigna/pdl-viewer/shared/gateway-util';
import * as fromTypeAHead from './+state/type-a-head/type-ahead.reducer';
import { TypeAHeadEffects } from './+state/type-a-head/type-ahead.effects';
import { TypeAHeadFacade } from './+state/type-a-head/type-ahead.facade';
import { FormularyEffects } from './+state/formulary/formulary.effects';
import { FormularyFacade } from './+state/formulary/formulary.facade';

@NgModule({
  imports: [
    CommonModule,
    PdlViewerSharedGatewayModule,
    StoreModule.forFeature(
      fromFormulary.FORMULARY_FEATURE_KEY,
      fromFormulary.reducer,
    ),
    EffectsModule.forFeature([FormularyEffects]),
    StoreModule.forFeature(
      fromTypeAHead.TYPEAHEAD_FEATURE_KEY,
      fromTypeAHead.thReducer,
    ),
    EffectsModule.forFeature([TypeAHeadEffects]),
  ],
  providers: [FormularyFacade, TypeAHeadFacade],
})
export class PdlViewerDrugSearchDataAccessModule {}
